import React from 'react';

const Glossary: React.FC<{
  block: any;
  glossaryEdges: { node: GlossaryItem }[];
}> = ({ block, glossaryEdges }) => {
  if (glossaryEdges.length === 0) {
    return null;
  }

  return (
    <section className={`block ${block._template} ${block.css_class_name}`}>
      <h3 className='glossary-title'>{block.title}</h3>
      {glossaryEdges.map(({ node }) => (
        <Item
          key={`glossary-item-${node.Id}`}
          item={node}
        />
      ))}
    </section>
  );
};

const ItemTitle: React.FC<{
  item: GlossaryItem;
}> = ({ item: { LinkToArticle, Content } }) => {
  if (!LinkToArticle) {
    return <p className='glossary-item__title'>{Content}</p>;
  }
  return (
    <a
      className='glossary-item__title'
      href={LinkToArticle}
    >
      {Content}
    </a>
  );
};

const Item: React.FC<{ item: GlossaryItem }> = ({ item }) => {
  return (
    <div className='glossary-item'>
      <ItemTitle item={item} />
      <p className='glossary-item__text'>{item.Description}</p>
    </div>
  );
};

export default Glossary;
